import React from 'react';

const LegalDisclaimer: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Legal & Disclaimers</h1>
        <div className="legal-content">
          <h2>Information Disclaimer</h2>
          <p>
            PrediEdge provides information and analytics about trading activity on Polymarket and other prediction markets. 
            <strong> This is not investment advice.</strong>
          </p>
          <p>
            The information displayed in this application, including whale trades, market signals, and sentiment indicators, 
            is for informational and analytical purposes only. It should not be construed as financial advice, 
            investment recommendations, or trading signals.
          </p>

          <h2>No Trading or Gambling Functionality</h2>
          <p>
            <strong>PrediEdge does not offer or facilitate any form of wagering, betting, or gambling.</strong>
          </p>
          <p>
            PrediEdge does not execute trades, hold user funds, or facilitate any transactions. All trading activity 
            occurs directly on Polymarket or other external platforms. PrediEdge is purely an analytics and monitoring tool.
          </p>

          <h2>Data Accuracy</h2>
          <p>
            While we strive to provide accurate and up-to-date information, PrediEdge makes no warranties or 
            guarantees about the accuracy, completeness, or timeliness of the data displayed. Market data is 
            sourced from third-party APIs and may be subject to delays or errors.
          </p>

          <h2>User Responsibility</h2>
          <p>
            Users are solely responsible for their own investment decisions. You should conduct your own research 
            and consult with qualified financial advisors before making any trading or investment decisions.
          </p>

          <h2>Risk Warning</h2>
          <p>
            Prediction markets involve substantial risk of loss. Past performance is not 
            indicative of future results. Only invest what you can afford to lose.
          </p>

          <h2>Privacy & Data</h2>
          <p>
            PrediEdge collects email addresses for authentication purposes only. We use analytics to improve 
            the application experience but do not track users across other apps or websites owned by third parties.
          </p>
          <p>
            For more information about how we handle your data, please contact us at support@prediedge.com.
          </p>

          <h2>Third-Party Services</h2>
          <p>
            PrediEdge integrates with third-party services including Polymarket, Kalshi, and other prediction markets. 
            We are not affiliated with, endorsed by, or sponsored by these platforms. Use of these platforms is subject 
            to their respective terms of service.
          </p>

          <h2>Changes to This Notice</h2>
          <p>
            We may update this legal notice from time to time. Continued use of PrediEdge constitutes acceptance of 
            any changes.
          </p>

          <h2>Contact</h2>
          <p>
            If you have questions about these terms or PrediEdge, please contact us at support@prediedge.com.
          </p>

          <p className="last-updated">Last updated: November 2025</p>
        </div>
      </div>
    </div>
  );
};

export default LegalDisclaimer;

